const getFormattedNumber = (number = 0, precise = 4) => {
  const [integerNumber, floatingNumber] = number.toString().split('.');

  return Number(
    floatingNumber ? `${integerNumber}.${floatingNumber.slice(0, precise)}` : integerNumber,
  );
};

export default getFormattedNumber;
